/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, { useState } from "react";

import GLOBALTEAM from "./GLOBALTEAM";

import { IObrienRetailersViewProps } from "./obrien-retailers";

export default (props: IObrienRetailersViewProps) => {
  const [globalteam] = useState([
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2w5A?pubver=1",
      title: "Alberg Ski and Sport",
      link: "https://www.arlbergski.com/pages/search-results-page?q=O%27Brien&page=1&rb_vendor=O%27Brien",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2tum?pubver=1",
      title: "Amazon",
      link: "https://www.amazon.com/stores/OBrienWatersports/Homepage/page/1F5E5931-D458-4CE0-9866-A49E80F7E5EF",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2tud?pubver=1",
      title: "Barts",
      link: "https://barts.com/obrien-international#/pageSize=36&viewMode=grid&orderBy=5&pageNumber=1",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2w5B?pubver=1",
      title: "Buy Wake",
      link: "https://www.buywake.com/brand/o-brien",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2tuj?pubver=1",
      title: "Dick's Sporting Goods",
      link: "https://www.dickssportinggoods.com/search/SearchDisplay?categoryId=&storeId=15108&catalogId=12301&langId=-1&sType=SimpleSearch&resultCatEntryType=2&showResultsPage=true&fromPage=Search&searchSource=Q&pageView=&beginIndex=0&pageSize=48&searchTerm=OBrien&selectedStore=748&DSGsearchType=Keyword&advsearch=true&SearchType=Keyword",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2tuc?pubver=1",
      title: "Evo",
      link: "https://www.evo.com/shop/obrien",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2yGV?pubver=1",
      title: "Leisure Pro",
      link: "https://www.leisurepro.com/brands/OBrien",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2tup?pubver=1",
      title: "Marine Products",
      link: "https://marine-products.com/search?type=article%2Cpage%2Cproduct&q=O%27Brien*",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2w5G?pubver=1",
      title: "Overtons",
      link: "https://www.overtons.com/search?q=O%27Brien&lang=default",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2w5v?pubver=1",
      title: "Performance",
      link: "https://www.perfski.com/brands/obrien",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2yGW?pubver=1",
      title: "Peter Glenn",
      link: "https://www.peterglenn.com/category/wake%20and%20waterski?filters=im_vid_6:197",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2yH2?pubver=1",
      title: "Redshift",
      link: "https://www.redshiftwatersports.com/brand/o-brien",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2yGM?pubver=1",
      title: "Ride the Wave",
      link: "https://ridewatersports.com/brands/O%27BRIEN.html",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2yGQ?pubver=1",
      title: "Ski Doo Outlet",
      link: "https://skidoooutlet.com/brand/obrien-watersports/?season=water",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2w5H?pubver=1",
      title: "Sports & Marine Parafunalia",
      link: "http://search.store.yahoo.net/yhst-89929770490774/cgi-bin/nsearch?vwcatalog=yhst-89929770490774&query=O%27Brien&.autodone=http%3A%2F%2Fyhst-89929770490774.us-dc1-edit.store.yahoo.net%2FRT%2FNEWEDIT.yhst-89929770490774%2F49686e88f32b%2Fnorder.html",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2yGN?pubver=1",
      title: "Summit Sports",
      link: "https://www.summitsports.com/search?prefn1=brand&prefv1=O%27Brien",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2w5u?pubver=1",
      title: "The House",
      link: "https://www.the-house.com/vendor-obrienstore.html",
    },
    {
      image:
        "https://images-us-prod.cms.commerce.dynamics.com/cms/api/nwtfklkdlc/imageFileData/MC2tul?pubver=1",
      title: "Wholesale Marine",
      link: "https://www.wholesalemarine.com/brands/OBrien-Watersports.html?sort=featured&page=1&_bc_fsnf=1&in_stock=1&category=7842",
    },
  ]);

  

  

  
  return (
    
    <div className="teams auto-grid-mod">
      {globalteam.map((globalteam, i) => (
        <GLOBALTEAM
          globalteam={globalteam}
          index={i}
        />
      ))}
    </div>
    
  );
};
